import { Injectable } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';

import { BaseChartConfig } from 'src/app/shared/components/disease-insight-chart/base-chart.config';

@Injectable()
export class DownyMildewChartConfig extends BaseChartConfig {
  getRightAxisTitle(): string {
    return 'mm';
  }

  getInfectionRiskLabel(localeService: LocaleService): string {
    return localeService.translate('blight.infectionRisk');
  }

  getIsHourlyData(): boolean {
    return true;
  }
}
